export enum MODAL_CUT_CONFIRMATION_TYPE {
  CONFIRM = 'confirm',
  LATER = 'later',
}
